export default "__VITE_ASSET__b4285298__"